module.exports = __webpack_public_path__ + "static/media/Emotes-Realistic-Landscape.f9bf5b84.png";